import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { RootState } from '../../stores/store';
import { workspaceOptions } from '../../stores/workspaces/selectors';
import MultiSelect from '../common/MultiSelect';

interface Props extends LocalizeContextProps {
    isMulti?: boolean;
    selected: string[] | string;
    workspaces: Array<{ label: string, value: string }>;
    selection?: ValueType<{ label: string, value: string }> | { label: string, value: string } | null;
    updateSelection: (selection: ValueType<{ label: string, value: string }> |
         { label: string, value: string }) => void;
}

class WorkspaceSelect extends React.Component<Props> {
    public componentDidMount() {
        if (this.props.isMulti) {
            this.props.updateSelection(
                this.props.workspaces.filter((workspace) =>
                    (this.props.selected as string[]).find((id) => workspace.value === id))
            );
        } else {
            this.props.updateSelection(this.props.workspaces.find((workspace) =>
                workspace.value === this.props.selected)!);
        }
    }

    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                {!this.props.isMulti ? (
                    <Select className={"dropdown-select workspace-select"}id={"workspace-select"}
                        options={this.props.workspaces}
                        value={this.props.selection}
                        onChange={this.handleSelectChange}
                    />
                ) : (
                        <MultiSelect className={"dropdown-select workspace-multiselect workspace-select"} id={"workspace-multiselect"}
                            options={this.props.workspaces}
                            value={this.props.selection}
                            onChange={this.handleSelectChange}
                        />
                    )}
            </React.Fragment>
        );
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        if (this.props.isMulti) {
            this.props.updateSelection((val === null || val === undefined) ? [] : val);
        } else {
            if (val === null || val === undefined) { return; }
            // tslint:disable-next-line:no-any
            this.props.updateSelection(val as any);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    workspaces: workspaceOptions(state),
});

export default connect(mapStateToProps)(withLocalize(WorkspaceSelect));